import Mastercard from "../../../../images/mastercard-logo.png"
import clsx from "clsx";
import Visa from "../../../../images/visa.png"
import Amex from "../../../../images/amex.png"
import { FormControl, useFormControlContext } from "@mui/base/FormControl";
import { Input } from '@base-ui-components/react/input';
import InputMask from "react-input-mask";
import { State, Country } from "country-state-city";
import { styled } from "@mui/system";
import '../../Account/Address/HomeAddresses.css'
import { Helmet } from "react-helmet-async";
import { Checkbox, FormControlLabel } from '@mui/material';

import { Grid, Tooltip, Select, MenuItem, FormHelperText } from "@mui/material";
import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import './Checkout.css'
import HeaderV3 from '../../molecules/Header/HeaderV3/HeaderV3'
import LoadingScreen from "../../LoadingScreen/Loading";
import { useDispatch } from 'react-redux';
import { getCartItems } from "../../../../redux/cartReducer";
import { useSelector } from 'react-redux';
import AuthContext from "../../../../store/auth-context";
import { mobileStyle } from "../../Home";
import userServices from "../../../../services/user-services";
import { getDiscount, getDisplayPrice, getDisplayVariantPrice, getVariantDiscount } from "../../../../utils/displayPrice";
import orderServices from "../../../../services/order-services";
import { useLocation, useNavigate } from "react-router-dom";
import logger from "../../../../utils/logger";
import constants from "../../../../constants/en";
import { Purchase } from "../../../../utils/meta-pixel-tracking";
import { resetCart } from "../../../../redux/cartReducer";
import NewFooterV2 from "../../molecules/NewFooter/NewFooterV2/NewFooterV2";
import authService from "../../../../services/auth-services";

import {
  guestCreatePayment,
  fetchSavedCard,
  createGuestCard,
  updateGuestCard
} from "../../../../services/payment-services";
import DialogMui from "../../molecules/Dialog/Dialog";

const totalprice = (cartItems) => {
  let sumWithoutDiscount = 0;
  let sum = 0;
  let advatixSum = 0;
  let selfSum = 0;
  let virtualSum = 0;
  let ediSum = 0;
  let discountPriceSum = 0;
  for (let i = 0; i < cartItems?.length; i++) {
    if (cartItems[i]?.auction_item?.store_item?.variant) {
      if (cartItems[i]?.auction_item?.store_item?.variant.quantity_in_stock >= cartItems[i].quantity) {
        sum += (Number(+cartItems[i]?.quantity)) * Number(getDisplayVariantPrice(cartItems[i]?.auction_item?.store_item?.variant, cartItems[i]?.auction_item));
        discountPriceSum += (Number(+cartItems[i]?.quantity)) * Number(getVariantDiscount(cartItems[i]?.auction_item?.store_item?.variant, cartItems[i]?.auction_item));
        if (cartItems[i].auction_item.fulfilment.name === "advatix") {
          advatixSum += (Number(+cartItems[i]?.quantity)) * Number(getDisplayVariantPrice(cartItems[i]?.auction_item?.store_item?.variant, cartItems[i]?.auction_item))
        } else if (cartItems[i].auction_item.fulfilment.name === "self") {
          selfSum += (Number(+cartItems[i]?.quantity)) * Number(getDisplayVariantPrice(cartItems[i]?.auction_item?.store_item?.variant, cartItems[i]?.auction_item))
        } else if (cartItems[i].auction_item.fulfilment.name === "edi") {
          ediSum += (Number(+cartItems[i]?.quantity)) * Number(getDisplayVariantPrice(cartItems[i]?.auction_item?.store_item?.variant, cartItems[i]?.auction_item))
        } else {
          virtualSum += (Number(+cartItems[i]?.quantity)) * Number(getDisplayVariantPrice(cartItems[i]?.auction_item?.store_item?.variant, cartItems[i]?.auction_item))
        }
      }

    } else {
      if (cartItems[i]?.auction_item?.store_item?.quantity_in_stock >= cartItems[i].quantity) {
        sum += (Number(+cartItems[i]?.quantity)) * (Number(getDisplayPrice(cartItems[i]?.auction_item)));
        discountPriceSum += (Number(+cartItems[i]?.quantity)) * (Number(getDiscount(cartItems[i]?.auction_item)))
        if (cartItems[i].auction_item.fulfilment.name === "advatix") {
          advatixSum += (Number(+cartItems[i]?.quantity)) * (Number(getDisplayPrice(cartItems[i]?.auction_item)))
        } else if (cartItems[i].auction_item.fulfilment.name === "self") {
          selfSum += (Number(+cartItems[i]?.quantity)) * (Number(getDisplayPrice(cartItems[i]?.auction_item)))
        } else if (cartItems[i].auction_item.fulfilment.name === "edi") {
          ediSum += (Number(+cartItems[i]?.quantity)) * (Number(getDisplayPrice(cartItems[i]?.auction_item)))
        } else {
          virtualSum += (Number(+cartItems[i]?.quantity)) * (Number(getDisplayPrice(cartItems[i]?.auction_item)))
        }
      }
    }
  }
  sumWithoutDiscount = sum;
  return [sum - discountPriceSum, advatixSum - discountPriceSum, selfSum - discountPriceSum, virtualSum - discountPriceSum, ediSum - discountPriceSum, discountPriceSum, sumWithoutDiscount];
};

const totalTaxablePrice = (cartItems) => {
  let sum = 0;
  for (const item of cartItems) {
    if (+item?.auction_item?.store_item?.charge_tax !== 0) {
      if (item?.auction_item?.store_item?.variant) {
        if (item?.auction_item?.store_item?.variant.quantity_in_stock >= item.quantity) {
          sum += (+item?.quantity) * ((Number(getDisplayVariantPrice(item?.auction_item?.store_item?.variant, item?.auction_item))) - (Number(getVariantDiscount(item?.auction_item?.store_item?.variant, item?.auction_item))));
        }

      } else {
        if (item?.auction_item?.store_item?.quantity_in_stock >= item.quantity) {
          sum += (+item?.quantity) * ((getDisplayPrice(item?.auction_item)) - (getDiscount(item?.auction_item)));
        }
      }
    }
  }
  return sum
}
function GuestCheckout() {
  // payment details state
  const [country, setCountry] = useState("US");
  const [addressState, setAddressState] = useState("CA");
  const [cardExpiry, setCardExpiry] = useState("");
  const fullNameRef = useRef('');
  const cardNumberRef = useRef('');
  const cvvRef = useRef('');
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [phone, setPhone] = useState("");
  const [shippingAddress, setShippingAddress] = useState(false)
  const [doneMessage, setDoneMessage] = useState(false)
  const [alertMsg, setAlertMsg] = useState(null)
  // const [alert, setAlert] = useState(false)
  const [addressLine1, setAddressLine1] = useState("")
  const [addressLine2, setAddressLine2] = useState("")
  const [addressCity, setAddressCity] = useState("")
  const [addressZip, setAddressZip] = useState("")
  const [cardNumber2, setCardNumber2] = useState("")
  // end payment details state

  // add shipping address state
  const [toFirstName, setToFirstName] = useState('');
  const [toLastName, setToLastName] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [zip, setZip] = useState('');
  const [addressPhone, setAddressPhone] = useState('');
  const phoneRef = useRef();
  const [addressCountry, setaddressCountry] = useState('US');
  const [cityState, setCityState] = useState('');
  const [city, setCity] = useState('');
  const [deliveryOption, setDeliveryOption] = useState('2');

  const codesObj = {};

  // end add shipping address state


  const location = useLocation();
  const primaryColor = mobileStyle.color[1]
  let currentDiscountFromAuction = [];
  const { data: cartItems } = useSelector(state => state.cartDetails)
  const dispatch = useDispatch();
  const [isOrderProcessing, setIsOrderProcessing] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const authCtx = useContext(AuthContext);
  const [updateQty, setUpdateQty] = useState(false);
  const [price, setPrice] = useState(0);
  const [discountPrice, setDiscountPrice] = useState(0);
  const [shippingRate, setShippingRate] = useState(0);
  const [tax, setTax] = useState(0);
  const [showDiscountPercentage, setShowDiscountPercentage] = useState(true);
  const [userShippingDetails, setUserShippingDetails] = useState(null);
  const navigate = useNavigate();
  const [cardDetails, setCardDetails] = useState(null);
  const [advatixItems, setAdvatixItems] = useState([])
  const [ediOrderItems, setEdiOrderItems] = useState([]);
  const [ediOrderItemsByDonor, setEdiOrderItemsByDonor] = useState([]);
  const [selfOrderItems, setselfOrderItems] = useState([])
  const [virtualItems, setvirtualItems] = useState([])

  const [modal, setModal] = useState({ isOpen: false, message: '' });
  const [noOfEvent, setNumberOfevent] = useState(1);
  const [uniqueEventId, setUniqueEventId] = useState(null);

  const [advatixItemPrice, setadvatixItemPrice] = useState(0);
  const [selfOrderItemPrice, setSelfOrderItemPrice] = useState(0);
  const [virtualOrderItemPrice, setvirtualOrderItemPrice] = useState(0);
  const [ediOrderItemPrice, setEdiOrderItemPrice] = useState(0);
  const [totalPriceWithoutDiscount, setTotalPriceWithoutDiscount] = useState(0);

  const [advatixShippingRate, setadvatixShippingPrice] = useState(0);
  const [selfShippingRate, setselfShippingPrice] = useState(0);
  const [ediShippingRate, setEdiShippingPrice] = useState(0);

  const [advatixSaleTax, setadvatixSaleTax] = useState(0);
  const [selfItemSaleTax, setSelfItemSaleTax] = useState(0);
  const [virtualSaleTax, setVirtualSaleTax] = useState(0);
  const [ediSaleTax, setEdiSaleTax] = useState(0);

  const [openConfirmAlert, setOpenConfirmAlert] = useState(false);
  const [email, setEmail] = useState('');

  const [shipTrigger, setShipTrigger] = useState(false);
  const [payTrigger, setPayTrigger] = useState(false);

  const [cus_id, setCusId] = useState(null);
  const [card_id, setCardId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [alerts, setAlert] = useState(false)

  const primaryBackgroundColor = "var(--pure-white)";
  const redColor = mobileStyle.color[0];
  const [sameAsBilling, setSameAsBilling] = useState(false);

  const handleCloseConfirmAlert = () => {
    setOpenConfirmAlert(false);
  };
  // payment function 
  const countries = useMemo(() => {
    return Country.getAllCountries().map((c) => {
      return {
        label: c.name,
        value: c.isoCode,
      };
    });
  }, []);
  const handleExpiryDate = ({ target }) => {
    const { value } = target;
    if (value.length < 3) {
      if (value.length === 0) setCardExpiry("");
      const val = value.split("/")[0];
      const numVal = parseInt(val, 10);
      if (val.length === 1 && numVal > 1) setCardExpiry(`0${numVal}`);
      else if (val.length === 1) setCardExpiry(val);

      if (val.length === 2 && numVal > 12) setCardExpiry(`01/${numVal - 10}`);
      else if (val.length === 2) setCardExpiry(val);
    } else {
      const vs = value.split("/");
      if (vs.length < 2)
        setCardExpiry(`${value.slice(0, 2)}/${value.slice(2)}`);
      else
        parseInt(vs[0]) <= 12
          ? setCardExpiry(`${vs[0]}/${vs[1]}`)
          : setCardExpiry("");
    }
  };
  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/[^\d+]/g, '');
    const hasPlus = cleaned.startsWith('+');
    const digits = cleaned.replace(/\D/g, '');

    let formatted = '';

    if (digits.length <= 3) {
      formatted = digits;
    } else if (digits.length <= 6) {
      formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
    } else {
      formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    }

    return hasPlus ? `+${formatted}` : formatted;
  };
  const guestPaymentUpdate = async (customerId, guestcardId, token, id) => {
    // e.preventDefault();
   const newPhoneNumber = phoneRef.current
  ? phoneRef.current.value.replace(/-/g, '')
  : '';

    const expiryDate = cardExpiry.split("/");
    setLoading(true)
    try{
    if (sameAsBilling) {
      const obj = {
        to_firstname: fullNameRef.current?.value,
        to_lastname: fullNameRef.current?.value,
        address1: addressLine1,
        address2: addressLine2,
        city: addressCity,
        state: addressState,
        phone: newPhoneNumber,
        country: country,
        zip: addressZip,
        email: email,
      };
      await userServices.postGuestShippingAddress(token, obj, id);

    }
    if (customerId && guestcardId) {
      const res= await updateGuestCard({
        number: cardNumberRef.current?.value.replace(/-/g, ""),
        exp_month: expiryDate[0],
        exp_year: expiryDate[1],
        cvc: cvvRef.current?.value,
        name: fullNameRef.current?.value,
        address_line1: addressLine1,
        address_line2: addressLine2,
        address_country: country,
        address_state: addressState,
        address_zip: addressZip,
        address_city: addressCity,
        phone: newPhoneNumber,
        oldCusID: customerId,
        oldCardID: guestcardId,
      }, token)
          if(res.data.success){
            return true
          }else{
            return false
          }
    
    } else {
     const res= await createGuestCard({
        number: cardNumberRef.current?.value.replace(/-/g, ""),
        exp_month: expiryDate[0],
        exp_year: expiryDate[1],
        cvc: cvvRef.current?.value,
        name: fullNameRef.current?.value,
        address_line1: addressLine1,
        address_line2: addressLine2,
        address_country: country,
        address_state: addressState,
        address_zip: addressZip,
        address_city: addressCity,
        phone: newPhoneNumber,

      }, token)

       if(res.data.success){
            return true
          }else{
            return false
          }
        }
      }catch(err){
          const errorMessage = err?.response?.data?.message || constants.APP_COPY_CARD_DETAILS_ERROR;
           setAlertMsg(errorMessage)
          setAlert(true)
        setIsOrderProcessing(false);
          return false;

        };
    // }
  };

  // end  payment function 

  // address function
  const updatedState = (country) => {
    return State.getStatesOfCountry(country).map((s) => {
      return {
        label: s.name,
        value: s.isoCode,
      };
    });
  };

  const handlePhone = (e) => {
    setAddressPhone(e.target.value);
  };
  const handleSubmitAddress = async (token, id) => {
    // e.preventDefault();
    try {
      const USZipCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/
    const newPhoneNumber = phoneRef.current
  ? phoneRef.current.value.replace(/-/g, '')
  : '';

      if (!zip.match(USZipCodeRegex)) {
        setIsOrderProcessing(false);
        setAlertMsg('Invalid Zip Code')
        return false
      }
      else {
        const obj = {
          to_firstname: toFirstName?.trim(),
          to_lastname: toLastName?.trim(),
          address1,
          address2,
          city,
          state: cityState,
          phone: newPhoneNumber,
          country: country,
          zip
        };
     const response= await userServices.postGuestShippingAddress(token,obj,id)
     if(response.data){
      return true
     }else{
       setAlertMsg(response.response?.data?.data[0].msg||constants.APP_COPY_FAILED_SHIPPING_ADDRESS)
      setAlert(true)
      return false
     }
      }
    } catch (error) {
      logger('./pages/components/ShippingInformation.jsx', 'handleSubmit(): catch', error);
      setAlertMsg(constants.APP_COPY_FAILED_SHIPPING_ADDRESS)
      setAlert(true)
      return false;
    }
  };
  const handGuestTax = async (amount, state) => {
    try {
      const tax = await orderServices.getGuestSalesTax(amount, state)
      if (tax.state !== "CA") {
        tax.amount = 0
      }
      setTax(tax)
      return tax
    } catch (error) {
      logger('./pages/components/organisms/cart/cart.jsx', 'getGuestSalesTax()', { error: error });
      if (!checkEmptyShipping(error)) {
        // If user has shipping and error is some thing else then we will go back to cart page.
        setAlertMsg(error.response.data.message || constants.APP_COPY_ORDER_SALES_TAX_ERROR)
        setAlert(true)
        return false
      }
      else {
        return true
      }
    }
  }
  // end address function

  if (cartItems.length > 0) {
    cartItems.forEach((item) => {

      const isDiscount = item.auction_item?.auction_auction_item_xrefs?.[0]?.auction?.discount_percentage ? item.auction_item?.auction_auction_item_xrefs?.[0]?.auction?.discount_percentage : item.auction_item?.auction?.discount_percentage;
      if (isDiscount) {
        currentDiscountFromAuction.push(isDiscount);
      }
    });

  }
  useEffect(() => {

    setIsLoading(true)
    dispatch(getCartItems({ loggedIn: authCtx.isLoggedIn }))

    setIsLoading(false)

  }, [updateQty]);

  useEffect(() => {
    const uniqueDiscounts = [...new Set(currentDiscountFromAuction)];

    if (uniqueDiscounts.length > 1 && showDiscountPercentage !== false) {
      setShowDiscountPercentage(false);
    } else if (uniqueDiscounts.length === 1) {
      setShowDiscountPercentage(true);
    }
  }, [cartItems.length, currentDiscountFromAuction]);

  useEffect(() => {

    if (authCtx.isLoggedIn) {
      fetchCardData();
      fetchShippingData();
    }
  }, [])


  const fetchCardData = async (customerId, guestCardId) => {
    let hasCardData = false;

    try {

      if (!customerId || !guestCardId) return hasCardData;

      const card = await fetchSavedCard(customerId, guestCardId)
      if (card && card.id) {
        setCardDetails({
          name: card.name,
          last4: card.last4,
          brand: card.brand
        })
        hasCardData = true;
      }
    }
    catch (error) {
      console.error(error);
    }

    return hasCardData;
  }

  const fetchShippingData = async (id) => {

    let hasShippingData = false;

    try {
      const res = await userServices.getGuestUserShippingAddress(
        id
      );
      if (res.data) {
        setUserShippingDetails(userShippingDetails);
        hasShippingData = true;
      }
    }
    catch (error) {
      console.error(error)
    }

    return hasShippingData;
  }


  useEffect(() => {
    const uniqueDiscounts = [...new Set(currentDiscountFromAuction)];

    if (uniqueDiscounts.length > 1 && showDiscountPercentage !== false) {
      setShowDiscountPercentage(false);
    } else if (uniqueDiscounts.length === 1) {
      setShowDiscountPercentage(true);
    }
  }, [cartItems.length, currentDiscountFromAuction]);

  const getShippingRate = async (cartItems) => {
    let sum = 0;
    let productsTotalWeight = 0;
    for (let i = 0; i < cartItems.length; i++) {
      if (cartItems[i].auction_item.is_virtual === 0 && cartItems[i].auction_item.fulfilment.pickup_type === "ship") {
        if (cartItems[i].auction_item.store_item.variant) {
          if (cartItems[i].auction_item.store_item.variant.quantity_in_stock >= cartItems[i].quantity) {
            productsTotalWeight += (+cartItems[i].auction_item?.weight) * (+cartItems[i].quantity);
          }
        } else {
          if (cartItems[i].auction_item.store_item.quantity_in_stock >= cartItems[i].quantity) {

            productsTotalWeight += (+cartItems[i].auction_item?.weight) * (+cartItems[i].quantity);
          }
        }
      }
    }
    // return sum;

    // new logic
    // if (productsTotalWeight > 0) {
    //   const shippingRate = await orderServices.getGuestShippingRate(
    //     productsTotalWeight
    //   );
    //   return +shippingRate?.data?.shipping_rate
    // }
    // else {
    // }
    return 0
  };

  const checkEmptyShipping = (error) => {
    if (error?.response?.data?.noShipping == true) {
      // if there is no shipping then we don't need to go back to the cart page. We need to move to shipping details page.
      return true
    }
    else {
      return false
    }
  }



  const getAdvatixSaleTax = async (amount, state) => {
    if (!state) return false

    try {
      const tax = await orderServices.getGuestSalesTax(amount, state)
      if (tax.state !== "CA") {
        tax.amount = 0
      }
      setadvatixSaleTax(tax)
      return tax
    } catch (error) {
      logger('./pages/components/organisms/cart/cart.jsx', 'getAdvatixSaleTax()', { error: error });
      if (!checkEmptyShipping(error)) {
        setAlertMsg(error.response.data.message || constants.APP_COPY_ORDER_SALES_TAX_ERROR)
        setAlert(true)
        return false
      }
      else {
        return true
      }
    }
  };

  const getSelfOrderSaleTax = async (amount, state) => {
    try {
      const tax = await orderServices.getGuestSalesTax(amount, state)
      if (tax.state !== "CA") {
        tax.amount = 0
      }
      setSelfItemSaleTax(tax)
      return tax
    } catch (error) {
      logger('./pages/components/organisms/cart/cart.jsx', 'getSelfOrderSaleTax()', { error: error });
      if (!checkEmptyShipping(error)) {
        setAlertMsg(error.response.data.message || constants.APP_COPY_ORDER_SALES_TAX_ERROR)
        setAlert(true)
        return false
      }
      else {
        return true
      }
    }
  };
  const getVirtualSaleTax = async (amount, state) => {
    try {
      const tax = await orderServices.getGuestSalesTax(amount, state)
      if (tax.state !== "CA") {
        tax.amount = 0
      }
      setVirtualSaleTax(tax)
      return tax
    } catch (error) {
      logger('./pages/components/organisms/cart/cart.jsx', 'getVirtualSaleTax()', { error: error });
      if (!checkEmptyShipping(error)) {
        setAlertMsg(error.response.data.message || constants.APP_COPY_ORDER_SALES_TAX_ERROR)
        setAlert(true)
        return false
      }
      else {
        return true
      }
    }
  };
  const getEdiSaleTax = async (amount, state) => {
    try {
      const tax = await orderServices.getGuestSalesTax(amount, state)
      setEdiSaleTax(tax)
      return tax
    } catch (error) {
      logger('./pages/components/organisms/cart/cart.jsx', 'getEdiSaleTax()', { error: error });
      if (!checkEmptyShipping(error)) {
        setAlertMsg(error.response.data.message || constants.APP_COPY_ORDER_SALES_TAX_ERROR)
        setAlert(true)
        return false
      }
      else {
        return true
      }
    }
  }

  const separateItems = (items) => {
    let advtItmes = [];
    let selfOrdItems = [];
    let virItems = [];
    let ediItems = [];
    let ediItemsByDonor = {}
    for (let i = 0; i < items.length; i++) {
      if (items[i].auction_item.store_item.variant) {
        if (items[i]?.auction_item?.store_item?.variant?.quantity_in_stock >= items[i].quantity) {
          if (items[i]?.auction_item?.fulfilment?.name === "advatix") {
            advtItmes.push(items[i])
          } else if (items[i]?.auction_item?.fulfilment?.name === "self") {
            selfOrdItems.push(items[i])
          } else if (items[i]?.auction_item?.fulfilment?.name === "virtual" || items[i]?.auction_item?.is_virtual === 1) {
            virItems.push(items[i])
          }
          else if (items[i]?.auction_item?.fulfilment?.name === "edi") {
            ediItems.push(items[i])
            const item = items[i];
            const donor_id = item?.auction_item?.donor_id;
            if (!ediItemsByDonor[donor_id]) {
              ediItemsByDonor[donor_id] = [];
            }
            ediItemsByDonor[donor_id].push(item);
          }
        }
      } else {
        if (items[i].auction_item.store_item.quantity_in_stock >= items[i].quantity) {
          if (items[i]?.auction_item?.fulfilment?.name === "advatix") {
            advtItmes.push(items[i])
          } else if (items[i]?.auction_item?.fulfilment?.name === "self") {
            selfOrdItems.push(items[i])
          } else if (items[i]?.auction_item?.fulfilment?.name === "virtual" || items[i]?.auction_item?.is_virtual === 1) {
            virItems.push(items[i])
          }
          else if (items[i]?.auction_item?.fulfilment?.name === "edi") {
            ediItems.push(items[i])
            const item = items[i];
            const donor_id = item?.auction_item?.donor_id;
            if (!ediItemsByDonor[donor_id]) {
              ediItemsByDonor[donor_id] = [];
            }
            ediItemsByDonor[donor_id].push(item);
          }
        }
      }
    }
    return [advtItmes, selfOrdItems, virItems, ediItems, Object.values(ediItemsByDonor)]/// the last element is the array which includes arrays with objects of items according to donor_id eg: [[{},{}], [{},{}], [{},{}]]
  }

  const calculateDonation = (item) => {
    var amt = 0;
    // console.log("this is item from calculation",item)
    const causeSharePercentage = (+item?.auction_item?.donor?.revenue_splits[0]?.cause_rev_share_percent / 100) || 0.8

    if (!item?.auction_item?.store_item_id) {
      //Auction
      // if (bidDetails?.data?.bidCount > 0) {
      //   amt = Number(bidDetails?.data?.bid_amount * causeSharePercentage);
      // }
      // else {
      //   amt = Number(bidDetails?.data?.price * causeSharePercentage);
      // }
    }
    else {

      let price = getDisplayPrice(item?.auction_item)
      let variantPrice = getDisplayVariantPrice(item?.auction_item?.store_item?.variant, item?.auction_item)
      if (item?.auction_item?.store_item?.variant) {
        amt = Number((variantPrice - Number(getVariantDiscount(item?.auction_item?.store_item?.variant, item?.auction_item))) * causeSharePercentage);
      }
      else {
        amt = Number((price - getDiscount(item?.auction_item)) * causeSharePercentage);
      }

    }

    return amt * (item?.quantity || 1);
  }


  useEffect(() => {
    setPrice(totalprice(cartItems)[6]);
    // if (!authCtx.isLoggedIn) {
    //   return
    // }
    (async () => {
      const getEventId = (items) => {
        let eventIds = [];
        for (let i = 0; i < items.length; i++) {
          if (items[i].auction_item.store_item.variant) {
            if (items[i]?.auction_item?.store_item?.variant?.quantity_in_stock >= items[i].quantity) {
              // eventIds.push(items[i]?.auction_item?.auction?.id)
              eventIds.push(items[i]?.auction_id)
            }
          } else {
            if (items[i].auction_item.store_item.quantity_in_stock >= items[i].quantity) {
              // eventIds.push(items[i]?.auction_item?.auction?.id)
              eventIds.push(items[i]?.auction_id)
            }
          }
        }
        return eventIds
      }


      const cardDetails = async () => {
        if (authCtx.cusId && authCtx.cardId) {
          const card = await fetchSavedCard(authCtx.cusId, authCtx.cardId)
          if (card && card.id) {
            setCardDetails({
              name: card.name,
              last4: card.last4,
              brand: card.brand
            })
          }
          else {
            setModal({ isOpen: true, message: constants.APP_COPY_CART_NO_CARD_DETAILS })
          }
        } else {
          setModal({ isOpen: true, message: constants.APP_COPY_CART_NO_CARD_DETAILS })
        }
      }

      function removeDuplicates(arr) {
        return [...new Set(arr)];
      }

      setPrice(totalprice(cartItems)[6]);
      setadvatixItemPrice(totalprice(cartItems)[1]);
      setSelfOrderItemPrice(totalprice(cartItems)[2]);
      setvirtualOrderItemPrice(totalprice(cartItems)[3])
      setEdiOrderItemPrice(totalprice(cartItems)[4])
      setDiscountPrice(totalprice(cartItems)[5])
      setTotalPriceWithoutDiscount(totalprice(cartItems)[6])
      cardDetails()
      setAdvatixItems(separateItems(cartItems)[0])
      setselfOrderItems(separateItems(cartItems)[1])
      setvirtualItems(separateItems(cartItems)[2])
      setEdiOrderItems(separateItems(cartItems)[3])
      setEdiOrderItemsByDonor(separateItems(cartItems)[4])

      // to get unique event ID to pass in state to buynow checkOut page
      if (removeDuplicates(getEventId(cartItems)).length > 1) {
        setNumberOfevent(2)
      } else {
        setNumberOfevent(1);
        setUniqueEventId(removeDuplicates(getEventId(cartItems))[0])
      }
      if (separateItems(cartItems)[0]?.length > 0) {
        getShippingRate(separateItems(cartItems)[0]).then((res) => {
          setadvatixShippingPrice(res);
        });
      }
      if (separateItems(cartItems)[1]?.length > 0) {
        getShippingRate(separateItems(cartItems)[1]).then((res) => {
          setselfShippingPrice(res);
        });
      }
      if (separateItems(cartItems)[4]?.length) {
        for (let itemsByDonor of separateItems(cartItems)[4]) {
          getShippingRate(itemsByDonor).then((res) => {
            setEdiShippingPrice((prev) => prev + res)
          })
        }
      }

    })()
  }, [cartItems]);

  useEffect(() => {
    setShippingRate(9.99) // Setting shipping rate to 9.99 per order
    // setShippingRate(+advatixShippingRate + +selfShippingRate + +ediShippingRate)
  }, [advatixShippingRate, selfShippingRate, ediShippingRate])

  const calculateSalesTax = async (state) => {

    const advItems = separateItems(cartItems)[0]
    if (advItems?.length) {
      const advTaxValue = await getAdvatixSaleTax(totalTaxablePrice(advItems), state);
      if (!advTaxValue) {
        return;
      }
    }
    const selfItems = separateItems(cartItems)[1]
    if (selfItems?.length) {
      const selfTax = await getSelfOrderSaleTax(totalTaxablePrice(selfItems), state);
      if (!selfTax) {
        return;
      }
    }
    const virItems = separateItems(cartItems)[2]
    if (virItems?.length) {
      const virTax = await getVirtualSaleTax(totalTaxablePrice(virItems), state);
      if (!virTax) {
        return;
      }
    }
    const ediItems = separateItems(cartItems)[3]
    if (ediItems?.length) {
      const ediTax = await getEdiSaleTax(totalTaxablePrice(ediItems), state);
      if (!ediTax) {
        return;
      }
    }
  }

  const calcFinalPrice = (price, shipping_price, tax) => {
    // console.log("this is price",price, shipping_price, tax)
    let _price = price ? +price : 0;
    let _shipping_price = shipping_price ? +shipping_price : 0;
    let _tax = tax && tax.amount ? +tax.amount : 0;
    let total = _price + _shipping_price + _tax;
    const proccessingFees = Number((_price * 0.03).toFixed(2));
    total += proccessingFees

    return { totalAmount: total, proccessingFees };
  };

  const calcCharityPercentage = (products) => {
    let charityAmount = 0;
    for (let prod of products?.flat(Infinity)) {
      const causeSharePercentage = (Number(prod?.auction_item?.donor?.revenue_splits[0]?.cause_rev_share_percent) / 100) || 0.8
      charityAmount += Number(getDisplayPrice(prod?.auction_item)) * causeSharePercentage * (Number(prod?.quantity) || 1)
    }
    return charityAmount
  }

  const shippingSaved = (e) => {
    calculateSalesTax();
  }

  const handleCheckout = async (e) => {

    if (!email) {
      setAlertMsg('Please enter a valid email address.');
      setAlert(true)
      return false;
    }
    if (fullNameRef.current?.value === '') {
      setAlertMsg('Please enter payment card holder name.');
      setAlert(true)
      return false;
    }
    if (cardNumberRef.current?.value === '') {
      setAlertMsg('Please enter payment card number.');
      setAlert(true)
      return false;
    }

    if (!cardExpiry) {
      setAlertMsg('Please enter payment card expiry date.');
      setAlert(true)
      return false;
    }
    if (cvvRef.current?.value === '') {
      setAlertMsg('Please enter payment card security code.');
      setAlert(true)
      return false;
    }

    if (!addressLine1) {
      setAlertMsg('Please enter billing street address.');
      setAlert(true)
      return false;
    }

    if (!addressState) {
      setAlertMsg('Please enter billing state.');
      setAlert(true)
      return false;
    }
    if (!addressCity) {
      setAlertMsg('Please enter billing city.');
      setAlert(true)
      return false;
    }
    if (!sameAsBilling && !toFirstName) {
      setAlertMsg('Please enter shipping first name.');
      setAlert(true)
      return false;
    }

    if (!sameAsBilling && !address1) {
      setAlertMsg('Please enter shipping street address.');
      setAlert(true)
      return false;
    }
    if (!sameAsBilling && !city) {
      setAlertMsg('Please enter shipping city.');
      setAlert(true)
      return false;
    }
    if (!sameAsBilling && !cityState) {
      setAlertMsg('Please select shipping state.');
      setAlert(true)
      return false;
    }
    const USZipCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/
    const newPhoneNumber = phone.replace(/-/g, '');
    if (!sameAsBilling && !zip.match(USZipCodeRegex)) {
      setAlertMsg('Invalid shipping zip code.');
      setAlert(true)
      return false;
    }


    setIsOrderProcessing(true);
    //Create guest user first from email
    let guestUserResponse = await authService.guestCheckout(email, sameAsBilling ? fullNameRef.current?.value : toFirstName, sameAsBilling ? '' : toLastName);

    if (!guestUserResponse || !guestUserResponse.success) {
      setAlertMsg('Email address is not valid or is already associated with an existing registered account.');
      setAlert(true)
      setIsOrderProcessing(false);
      return false;
    }

    let guestUser = guestUserResponse.user;
    let token = guestUserResponse.token
    //TODO: Let's simulate logging them with the authContext here now that we know the guest ID

    const response = await authService.verifyGuestUser(token);
    setUserId(guestUser.id)
    setCusId(response.cardData?.cus_id)
    setCardId(response.cardData?.card_id)
    const cus_Id = response.cardData.cus_id;
    const card_ID = response.cardData.card_id;


    //Update payment with whats on the page
    const success =await guestPaymentUpdate(cus_Id, card_ID, token, guestUser.id)
    const responseCard = await authService.verifyGuestUser(token);
    if(!success){
      setIsOrderProcessing(false);
      return
    }

    //Update shipping with what's on the page
    if (!sameAsBilling) {
    const addressSuccess=await handleSubmitAddress(token,guestUser.id)
     if(!addressSuccess){
      setIsOrderProcessing(false);
      return
    }}
      
    //Now fetch it back (if required)
    // const card = await fetchCardData(responseCard.cardData?.cus_id, responseCard.cardData?.card_id);
    // const shipping = await fetchShippingData(guestUser.id);

    //So we are all OK, we can process order now...
    e.preventDefault();

    try {
      // deduct amount
      const { totalAmount } = calcFinalPrice(price, shippingRate, tax)
      // create order using Advatix
      let totalOrderAmount = totalAmount
      try {
        const orderIds = {};
        const confirmOrder = {};
        let successItemsArray = []

        //Advatix Items
        if (advatixItems.length > 0) {
          let { totalAmount, proccessingFees } = calcFinalPrice(advatixItemPrice, advatixShippingRate, advatixSaleTax)
          let items = [];
          for (let i = 0; i < advatixItems.length; i++) {
            let price = null;
            if (advatixItems[i]?.auction_item?.store_item?.variant) {
              price = Number(getDisplayVariantPrice(advatixItems[i]?.auction_item?.store_item?.variant, advatixItems[i]?.auction_item)) - Number(getVariantDiscount(advatixItems[i]?.auction_item?.store_item?.variant, advatixItems[i]?.auction_item))
            } else {
              price = getDisplayPrice(advatixItems[i]?.auction_item) - getDiscount(advatixItems[i]?.auction_item)
            }
            items.push({
              price: price,
              quantity: advatixItems[i].quantity,
              product_sku_id: advatixItems[i].item_sku,
              auction_item_id: advatixItems[i].auction_item_id,
              auction_id: advatixItems[i]?.auction_id,
              cause_id: advatixItems[i].cause_id
            })
          }
          let orderPayload = {
            user_id: guestUser.id,
            order_amount: +totalAmount.toFixed(2),
            subtotal: advatixItemPrice,
            tax: +advatixSaleTax.amount,
            shipping_rate: +advatixShippingRate,
            proccessingFees: +proccessingFees.toFixed(2),
            items: items
          };

          const advatixOrder = await orderServices.createAdvatixGuestOrder(orderPayload, token);
          logger('./pages/components/organisms/cart/cart.jsx', 'handleCheckout(): create Advatix Order Response', { advatixOrder: advatixOrder });
          if (advatixOrder?.responseStatus && advatixOrder?.responseStatusCode === 200) {
            confirmOrder.advatixOrder = orderPayload.items;
            confirmOrder.advatix_amount = +totalAmount;
            orderIds.advatixOrderId = advatixOrder.BG_response;
            successItemsArray.push(advatixItems)
            for (let i = 0; i < advatixItems.length; i++) {
              //update quantity
              let qtyUpdatePayload = {
                sku: advatixItems[i].item_sku,
                quantity: +advatixItems[i].quantity,
                isStoreItem: true,
                isVirtual: advatixItems[i].auction_item?.is_virtual ? true : false,
              };
              await orderServices.updateGusetStoreItemQuantity(
                cartItems[i].auction_item_id,
                qtyUpdatePayload,
                token
              );
            }
          }
          else {
            totalOrderAmount = totalOrderAmount - totalAmount;
                  }
        }

        //Self Order
        if (selfOrderItems.length > 0) {
          let { totalAmount, proccessingFees } = calcFinalPrice(selfOrderItemPrice, selfShippingRate, selfItemSaleTax)
          let items = [];
          for (let i = 0; i < selfOrderItems.length; i++) {
            let price = null;
            if (selfOrderItems[i]?.auction_item?.store_item?.variant) {
              price = Number(getDisplayVariantPrice(selfOrderItems[i]?.auction_item?.store_item?.variant, selfOrderItems[i]?.auction_item)) - Number(getVariantDiscount(selfOrderItems[i]?.auction_item?.store_item?.variant, selfOrderItems[i]?.auction_item))
            } else {
              price = getDisplayPrice(selfOrderItems[i]?.auction_item) - getDiscount(selfOrderItems[i]?.auction_item)
            }
            items.push({
              price: price,
              quantity: selfOrderItems[i].quantity,
              product_sku_id: selfOrderItems[i].item_sku,
              auction_item_id: selfOrderItems[i].auction_item_id,
              auction_id: selfOrderItems[i]?.auction_id,
              cause_id: selfOrderItems[i].cause_id
            })
          }
          let orderPayload = {
            user_id: guestUser.id,
            order_amount: +totalAmount.toFixed(2),
            subtotal: selfOrderItemPrice,
            tax: +selfItemSaleTax.amount,
            shipping_rate: +selfShippingRate,
            proccessingFees: +proccessingFees.toFixed(2),
            items: items
          };
          const selfOrder = await orderServices.createGuestSelfOrder(orderPayload, token);
          logger('./pages/components/organisms/cart/cart.jsx', 'handleCheckout(): create Self Order Response', { selfOrder: selfOrder });
          successItemsArray.push(selfOrderItems)
          confirmOrder.selfOrder = orderPayload.items;
          confirmOrder.self_order_amount = +totalAmount;
          orderIds.selfOrderId = selfOrder.BG_response;
          for (let i = 0; i < selfOrderItems.length; i++) {
            //update quantity
            let qtyUpdatePayload = {
              sku: selfOrderItems[i].item_sku,
              quantity: +selfOrderItems[i].quantity,
              isStoreItem: true,
              isVirtual: selfOrderItems[i].auction_item?.is_virtual ? true : false,
            };
            await orderServices.updateGusetStoreItemQuantity(
              selfOrderItems[i].auction_item_id,
              qtyUpdatePayload,
              token
            );
          }

        }

        //EDI
        if (ediOrderItems.length > 0) {
          confirmOrder.ediOrder = [];
          orderIds.ediOrderId = []
          // let ediOrder = {}
          for (let i = 0; i < ediOrderItemsByDonor.length; i++) {
            // let {totalAmount,proccessingFees} = calcFinalPrice(ediOrderItemPrice, ediShippingRate, ediSaleTax)
            const itemsByDonor = ediOrderItemsByDonor[i]// here this will be again an array
            const ediItemsByDonorPrice = totalprice(itemsByDonor)[4]
            const ediItemsByDonorShippingRate = await getShippingRate(separateItems(itemsByDonor)[3])
            const ediItemsByDonorSalesTax = await getEdiSaleTax(totalTaxablePrice(separateItems(itemsByDonor)[3]));
            // console.log(ediItemsByDonorPrice, ediItemsByDonorShippingRate, ediItemsByDonorSalesTax, "ediItemsByDonorPrice, ediItemsByDonorShippingRate, ediItemsByDonorSalesTax")
            let { totalAmount, proccessingFees } = calcFinalPrice(ediItemsByDonorPrice, ediItemsByDonorShippingRate, ediItemsByDonorSalesTax)
            let items = [];
            for (let i = 0; i < itemsByDonor.length; i++) {
              let price = null;
              if (itemsByDonor[i]?.auction_item?.store_item?.variant) {
                price = Number(getDisplayVariantPrice(itemsByDonor[i]?.auction_item?.store_item?.variant, itemsByDonor[i]?.auction_item)) - Number(getVariantDiscount(itemsByDonor[i]?.auction_item?.store_item?.variant, itemsByDonor[i]?.auction_item))
              }
              else {
                price = getDisplayPrice(itemsByDonor[i]?.auction_item) - getDiscount(itemsByDonor[i]?.auction_item)
              }

              function getVendorSkuId(item) {
                if (item?.auction_item?.store_item?.variant && item?.auction_item?.store_item?.variant !== null) {
                  return item?.auction_item?.store_item?.variant?.vendor_sku_id
                }
                else {
                  return item?.auction_item?.store_item?.vendor_sku_id
                }
              }
              function getUPC(item) {
                if (item?.auction_item?.store_item?.variant && item?.auction_item?.store_item?.variant !== null) {
                  return item?.auction_item?.store_item?.variant?.upc
                }
                else {
                  return item?.auction_item?.store_item?.upc
                }
              }
              items.push({
                price: price,
                quantity: itemsByDonor[i].quantity,
                product_sku_id: itemsByDonor[i].item_sku,
                auction_item_id: itemsByDonor[i].auction_item_id,
                auction_id: itemsByDonor[i]?.auction_id,
                cause_id: itemsByDonor[i].cause_id,
                item_name: itemsByDonor[i].auction_item?.name,
                vendor_sku_id: getVendorSkuId(itemsByDonor[i]),
                upc: getUPC(itemsByDonor[i])
              })
            }
            let orderPayload = {
              user_id: guestUser.id,
              order_amount: +totalAmount.toFixed(2),
              subtotal: ediItemsByDonorPrice,
              tax: +ediItemsByDonorSalesTax.amount,
              shipping_rate: +ediItemsByDonorShippingRate,
              proccessingFees: +proccessingFees.toFixed(2),
              items: items
            };
            const ediOrder = await orderServices.createGuestEdiOrder(orderPayload, token);
            logger('./pages/components/organisms/cart/cart.jsx', 'handleCheckout(): create Edi Order Response', { ediOrder: ediOrder });
            if (ediOrder?.status === 200 && (ediOrder?.data?.path && ediOrder?.data?.url)) {
              // confirmOrder.ediOrder = [];
              // confirmOrder.ediOrder.push(orderPayload?.items);
              // confirmOrder.edi_order_amount = +totalAmount;
              ediOrder.BG_response.generatedFilePath = ediOrder?.data?.path
              ediOrder.BG_response.items = orderPayload?.items
              confirmOrder.ediOrder.push(ediOrder?.BG_response)
              orderIds.ediOrderId.push(ediOrder?.BG_response)
              // confirmOrder.ediOrder = orderPayload?.items;
              // orderIds.ediOrderId = ediOrder?.BG_response;
              // orderIds.ediOrderId.generatedFilePath = ediOrder?.data?.path;
              successItemsArray.push(itemsByDonor);

              for (let i = 0; i < itemsByDonor?.length; i++) {
                // update quantity
                let qtyUpdatePayload = {
                  sku: itemsByDonor[i].item_sku,
                  quantity: itemsByDonor[i].quantity,
                  isStoreItem: true,
                  isVirtual: itemsByDonor[i].auction_item?.is_virtual ? true : false,
                }
                // console.log(cartItems[i], "cartItems[i]")
                await orderServices.updateGusetStoreItemQuantity(
                  itemsByDonor[i].auction_item_id,
                  qtyUpdatePayload,
                  token
                );
              }

            }
            else {
              totalOrderAmount = totalOrderAmount - totalAmount;
            }
          }
        }

        //Virtual
        if (virtualItems.length > 0) {
          let { totalAmount, proccessingFees } = calcFinalPrice(virtualOrderItemPrice, 0, virtualSaleTax)
          let items = [];
          for (let i = 0; i < virtualItems.length; i++) {
            let price = null;
            if (virtualItems[i]?.auction_item?.store_item?.variant) {
              price = Number(getDisplayVariantPrice(virtualItems[i]?.auction_item?.store_item?.variant, virtualItems[i]?.auction_item)) - Number(getVariantDiscount(virtualItems[i]?.auction_item?.store_item?.variant, virtualItems[i]?.auction_item))
            } else {
              price = getDisplayPrice(virtualItems[i]?.auction_item) - getDiscount(virtualItems[i]?.auction_item)
            }
            items.push({
              price: price,
              quantity: virtualItems[i].quantity,
              product_sku_id: virtualItems[i].item_sku,
              auction_item_id: virtualItems[i].auction_item_id,
              auction_id: virtualItems[i]?.auction_id,
              cause_id: virtualItems[i].cause_id
            })
          }
          let orderPayload = {
            user_id: guestUser.id,
            order_amount: +totalAmount.toFixed(2),
            subtotal: virtualOrderItemPrice,
            tax: +virtualSaleTax.amount,
            shipping_rate: 0,
            proccessingFees: +proccessingFees.toFixed(2),
            items: items
          };
          const virtualOrder = await orderServices.createGuestVirtualOrder(orderPayload, token);
          logger('./pages/components/organisms/cart/cart.jsx', 'handleCheckout(): create Virtual Order Response', { virtualOrder: virtualOrder });
          successItemsArray.push(virtualItems)
          confirmOrder.virtualOrder = orderPayload.items;
          confirmOrder.virtual_amount = +totalAmount;
          orderIds.virtualOrderId = virtualOrder.BG_response;

          for (let i = 0; i < virtualItems.length; i++) {
            //update quantity
            let qtyUpdatePayload = {
              sku: virtualItems[i].item_sku,
              quantity: +virtualItems[i].quantity,
              isStoreItem: true,
              isVirtual: virtualItems[i].auction_item?.is_virtual ? true : false,
            };
            await orderServices.updateGusetStoreItemQuantity(
              virtualItems[i].auction_item_id,
              qtyUpdatePayload,
              token
            );
          }

        }

        ///payment
        let payload = {
          amount: Number(totalOrderAmount.toFixed(2)),
        };
        try {
          if (payload?.amount <= 0) {
            setAlertMsg(constants.APP_COPY_ORDER_FAILED);
            setAlert(true)
            logger('./pages/components/organisms/cart/cart.jsx', 'handleCheckout(): amount 0', payload);
            setIsOrderProcessing(false);
            return navigate(-1)
          }
          const response = await guestCreatePayment(payload, token);
          if (response.success) {
            await orderServices.guestConfirmOrder(orderIds, confirmOrder, token,successItemsArray);

            //meta pixel tracking event
            let content_ids = []
            let contents = []
            cartItems.map(item => {
              content_ids.push(item.auction_item_id)
              contents.push({
                name: item.auction_item.name,
                id: item.auction_item_id,
                sku: item.item_sku,
                quantity: item.quantity
              })
              return null
            })
            Purchase({ content_ids, contents, num_items: cartItems.length, value: totalOrderAmount.toFixed(2), currency: "USD" })
            setIsOrderProcessing(false);
            dispatch(resetCart())
            navigate('/guest-checkout', {
              state: {
                noOfEvent: noOfEvent,
                auctionId: uniqueEventId,
                charityAmount: Number(calculateTotalDonation(successItemsArray)).toFixed(2)
              }
            });
          }
        } catch (error) {
          logger('./pages/components/organisms/cart/cart.jsx', 'handleCheckout(): updating payment failure', { orderIds: orderIds });
          await orderServices.updateGuestPaymentFailure(orderIds, token);
          // restore advatix items
          for (let i = 0; i < advatixItems.length; i++) {
            //update quantity
            let qtyUpdatePayload = {
              sku: advatixItems[i].item_sku,
              quantity: +advatixItems[i].quantity,
              isStoreItem: true,
              isVirtual: advatixItems[i].auction_item?.is_virtual ? true : false,
              incrementStock: true
            };
            await orderServices.updateGusetStoreItemQuantity(
              cartItems[i].auction_item_id,
              qtyUpdatePayload,
              token
            );
          }

          ///restore self items
          for (let i = 0; i < selfOrderItems.length; i++) {
            //update quantity
            let qtyUpdatePayload = {
              sku: selfOrderItems[i].item_sku,
              quantity: +selfOrderItems[i].quantity,
              isStoreItem: true,
              isVirtual: selfOrderItems[i].auction_item?.is_virtual ? true : false,
              incrementStock: true
            };
            await orderServices.updateGusetStoreItemQuantity(
              selfOrderItems[i].auction_item_id,
              qtyUpdatePayload,
              token
            );
          }

          //  restore ediItems
          if (ediOrderItems.length) {
            for (let i = 0; i < ediOrderItems.length; i++) {
              //update quantity
              let qtyUpdatePayload = {
                sku: ediOrderItems[i].item_sku,
                quantity: +ediOrderItems[i].quantity,
                isStoreItem: true,
                isVirtual: ediOrderItems[i].auction_item?.is_virtual ? true : false,
                incrementStock: true
              };
              await orderServices.updateGusetStoreItemQuantity(
                ediOrderItems[i].auction_item_id,
                qtyUpdatePayload,
                token
              );
            }
          }

          ///restore virtual items
          for (let i = 0; i < virtualItems.length; i++) {
            //update quantity
            let qtyUpdatePayload = {
              sku: virtualItems[i].item_sku,
              quantity: +virtualItems[i].quantity,
              isStoreItem: true,
              isVirtual: virtualItems[i].auction_item?.is_virtual ? true : false,
              incrementStock: true
            };
            await orderServices.updateGusetStoreItemQuantity(
              virtualItems[i].auction_item_id,
              qtyUpdatePayload,
              token
            );
          }
          setAlertMsg(constants.APP_COPY_PAYMENT_FAILED);
          setAlert(true)
          setIsOrderProcessing(false);
        }

      } catch (error) {
        logger('./pages/components/organisms/cart/cart.jsx', 'handleCheckout(): catch1', error);
        // console.log('Error at handleCheckout() catch 1 ---', error)
        setAlertMsg(error?.response?.data?.responseMsg || error?.response?.data?.message || constants.APP_COPY_ORDER_FAILED);
        setAlert(true)
        setIsOrderProcessing(false);
        navigate(-1)
      }

    } catch (error) {
      logger('./pages/components/organisms/cart/cart.jsx', 'handleCheckout(): catch2', error);
      // console.log('Error at handleCheckout() catch 2 ---', error)
      setAlertMsg(error?.response?.data?.message || constants.APP_COPY_ORDER_FAILED);
      setAlert(true)
      setIsOrderProcessing(false);
      navigate(-1)
    }
  };

  const checkMaxQuantity = (item) => {
    if (item?.auction_item?.store_item?.variant) {
      if (item?.auction_item?.store_item?.variant?.quantity_in_stock <= item.quantity) {
        return true
      } else {
        return false
      }
    } else {
      if (item?.auction_item?.store_item?.quantity_in_stock <= item.quantity) {
        return true
      } else {
        return false
      }
    }
  }

  const handleQuantityDecrement = async (item) => {
    if (item?.quantity <= 1) {
      return
    } else {
      await userServices.updateQuantity({ quantity: item?.quantity - 1 }, item.id, authCtx.isLoggedIn)
    }
    setUpdateQty(!updateQty)
  }

  const handleQtyIncrement = async (item) => {
    if (item?.auction_item?.store_item?.variant) {
      if (item?.auction_item?.store_item?.variant?.quantity_in_stock === item.quantity) {
        return
      } else {
        await userServices.updateQuantity({ quantity: item?.quantity + 1 }, item.id, authCtx.isLoggedIn)
      }
    } else {
      if (item?.auction_item?.store_item?.quantity_in_stock === item.quantity) {
        return
      } else {
        await userServices.updateQuantity({ quantity: item?.quantity + 1 }, item.id, authCtx.isLoggedIn)
      }
    }
    setUpdateQty(!updateQty)
  }

  const calculateTotalDonation = () => {
    let totalAmt = 0; // Initialize total amount

    cartItems.forEach((item) => {
      const causeSharePercentage =
        (Number(item?.auction_item?.donor?.revenue_splits?.[0]?.cause_rev_share_percent) / 100) || 0.8;

      let amt = 0; // Initialize item amount

      if (item?.auction_item?.store_item_id) {
        amt = ((Number(getDisplayPrice(item.auction_item)) - Number(getDiscount(item.auction_item))) * causeSharePercentage);
        // Auction
        // Uncomment this if bidDetails is available
        // if (bidDetails?.data?.bidCount > 0) {
        //     amt = Number(bidDetails?.data?.bid_amount * causeSharePercentage);
        // } else {
        //     amt = Number(bidDetails?.data?.price * causeSharePercentage);
        // }
      } else {

 if (item?.auction_item.highestBid?.length) {
      amt = Number(item?.auction_item.highestBid[0]?.max_bid * causeSharePercentage);
    }
    else if (item?.auction.buy_now_price) {
      amt = Number(item?.auction_item.buy_now_price * causeSharePercentage);
    }
    else {
      amt = Number(item?.auction_item.store_item.price * causeSharePercentage);
    }
      }

      totalAmt += amt * (item?.quantity || 1);
    });

    return totalAmt;
  };

  return (
    <>
      <HeaderV3 />
      <div className='ch-main-div'>
        <h1 style={{ textAlign: 'center' }}>CHECKOUT</h1>
        <Grid container spacing={2} style={{ marginTop: '50px' }}>
          <Grid item xs={12} md={8}>
            <div className="padding">

              {isOrderProcessing && (
                <LoadingScreen loadingText='Processing Order...' />
              )}
              {
                isLoading && (
                  <LoadingScreen bgColor='rgb(240, 232, 227)' />
                )
              }

              <div style={{ paddingBottom: '20px' }}>You are checking out as a guest. For faster checkout in the future and better tracking please <a href="/login" style={{ cursor: 'pointer', textDecoration: 'underline' }}>login</a> or  <a href="/register" style={{ cursor: 'pointer', textDecoration: 'underline' }}>sign up</a>.</div>

              <div className={`address-information-container `}>
                <div className='address-info-name'>
                  <div style={{ color: primaryColor }} className='address-info_sub_heading'>
                    E-Mail (for tracking updates)<span style={{ color: redColor }}>*</span>
                  </div>
                  <input
                    style={{ border: `1px solid ${primaryColor}`, backgroundColor: primaryBackgroundColor }}
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    type='text'
                    name='email'
                    required
                  />
                </div>
              </div>


              {/* payment detail form */}
              <>
                <div style={{ height: 'auto' }} className="container-payment-add form-container">
                  {location.pathname === '/cart-checkout' && <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '20px' }}>Payment Details</h3>}

                  <div className="checkout">
                    <form >
                      <div className="">
                        <div className="three_cards">
                          <div className="card-icons-container">
                            <div style={{ fontSize: "0.8rem", fontWeight: "600" }}>We accept:</div>
                            <div className="card-icons visa_container">
                              <img className='visa_img' src={Visa} alt="" />
                            </div>
                            <div className="card-icons  master_container">
                              <img className='master_card_img' src={Mastercard} alt="" />
                            </div>
                            <div className="card-icons amex_container">
                              <img className='amex_img' src={Amex} alt="" />
                            </div>
                          </div>
                        </div>

                        <Grid container spacing={3}>
                          <Grid item xs={12} md={12}>
                            <FormControl required>
                              <Label>Name on Card</Label>
                              <Input
                                required
                                className={'field-input '}
                                ref={fullNameRef}
                                // onChange={(e) => fullNameRef.current = e.target.value}
                                placeholder="Full name on card"

                                style={{
                                  height: '35px',
                                  fontSize: '14px',
                                  borderRadius: '4px',
                                }}
                              />
                              <HelperText />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <FormControl required>

                              <Label>Card Number</Label>

                              <InputMask
                                value={cardNumber2}
                                placeholder="Card number"
                                mask={
                                  cardNumber2.length > 1 &&
                                    (cardNumber2.slice(0, 2) === "37" ||
                                      cardNumber2.slice(0, 2) === "34")
                                    ? "9999-999999-99999"
                                    : "9999-9999-9999-9999"
                                }
                                maskChar=""
                                ref={cardNumberRef}
                                onChange={(e) => setCardNumber2(e.target.value)}
                                className="form_input"
                                style={{
                                  borderRadius: '4px',
                                  fontSize: '14px',
                                  height: '35px',
                                  border: '1px solid #E5E1E1',
                                  padding: '10px',
                                  width: '100%'
                                }}
                                onBlur={(e) => (e.target.style.border = "1px solid grey")}
                                onMouseLeave={(e) => (e.target.style.border = "1px solid grey")}
                              />


                              <HelperText />
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <FormControl required>
                              <Label>Expiry Date</Label>

                              <input
                                className="card-secure-info__input"
                                type="tel"
                                name="expiry-date"
                                placeholder="MM/YY"
                                maxLength={5}
                                pattern="[0-9]{2}/[0-9]{2}"
                                required
                                value={cardExpiry}
                                onChange={handleExpiryDate}
                                style={{
                                  border: '1px solid grey', boxShadow: 'none'
                                }}
                              />

                              <HelperText />
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <FormControl required>
                              <Label>CVC</Label>
                              <input
                                className="card-secure-info__input"
                                type="text"
                                name="cvc"
                                placeholder="CVC"
                                pattern="[0-9]{3,}"
                                inputMode="numeric"
                                maxLength={3}
                                required
                                ref={cvvRef}
                                style={{ border: '1px solid grey', boxShadow: 'none' }}
                              />
                              <HelperText />
                            </FormControl>
                          </Grid>

                        </Grid>

                        <Grid container spacing={3}>
                          <Grid item xs={12} style={{ marginTop: '20px' }}>
                            <h5  >
                              Billing Address
                            </h5>
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <FormControl
                              defaultValue=""
                              required
                            >
                              <Input
                                required
                                className={'field-input'}
                                value={addressLine1}
                                onChange={(e) => setAddressLine1(e.target.value)}
                                placeholder="Address line 1" />
                              <HelperText />
                            </FormControl>

                          </Grid>
                          <Grid item xs={12} md={12}>
                            <FormControl
                              defaultValue=""

                            >
                              <Input
                                className={'field-input '}
                                value={addressLine2}
                                onChange={(e) => setAddressLine2(e.target.value)}
                                placeholder="Address line 2" />
                              <HelperText />
                            </FormControl>

                          </Grid>

                          <Grid item xs={12} md={12}>
                            <FormControl
                              defaultValue=""
                              required
                            >
                              <Input
                                required
                                placeholder="City"
                                className={'field-input '}
                                value={addressCity}
                                onChange={(e) => setAddressCity(e.target.value)}
                              />
                              <HelperText />
                            </FormControl>

                          </Grid>
                          <Grid item xs={12} md={12}>
                            <FormControl required>
                              <Select
                                required
                                placeholder="Select State"
                                value={addressState || ""}
                                onChange={(e) =>{setAddressState(e.target.value)
                              handGuestTax(totalTaxablePrice(cartItems), e.target.value)
                                  calculateSalesTax(e.target.value)}}
                                displayEmpty
                                style={{ width: '100%' }}
                                sx={{
                                  padding: 0,
                                  "& .MuiSelect-select": {
                                    padding: 1,
                                    border: '1px solid grey',
                                    borderRadius: '8px'
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "rgba(0, 0, 0, 0.23)",
                                    border: '1px solid grey',
                                    borderRadius: '8px'
                                  },
                                }}
                              >
                                <MenuItem value="" disabled>
                                  <em>Select State</em>
                                </MenuItem>
                                {State.getStatesOfCountry("US").map((state) => (
                                  <MenuItem key={state.isoCode} value={state.isoCode}>
                                    {state.name} ({state.isoCode})
                                  </MenuItem>
                                ))}
                              </Select>

                              <HelperText />
                            </FormControl>


                          </Grid>

                         

                          <Grid item xs={12} md={6}>
                            <FormControl
                              defaultValue=""
                              required
                            >
                              <Input
                                maxLength={6}
                                placeholder="Zip Code"
                                className={'field-input '}
                                value={addressZip}
                                onChange={(e) => setAddressZip(e.target.value)}
                              />
                              <HelperText />
                            </FormControl>

                          </Grid>

                          <Grid item xs={12} md={6}>
                            <FormControl required>
                              <Select
                                value={country || ""}
                                placeholder="Select Country"
                                onChange={(e) => setCountry(e.target.value)}
                                displayEmpty
                                style={{ width: '100%' }}
                                sx={{
                                  padding: 0,
                                  "& .MuiSelect-select": {
                                    padding: 1,
                                    border: '1px solid grey',
                                    borderRadius: '8px'
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "rgba(0, 0, 0, 0.23)",
                                    border: '1px solid grey',
                                    borderRadius: '8px',
                                    outline: 'none'
                                  },
                                }}
                              >
                                <MenuItem value="" disabled>
                                  <em>Select Country</em>
                                </MenuItem>
                                {countries.map((country) => (
                                  <MenuItem key={country.value} value={country.value}>
                                    {country.label} ({country.value})
                                  </MenuItem>
                                ))}
                              </Select>

                              <HelperText />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </div>
                    </form>
                  </div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={sameAsBilling}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setSameAsBilling(checked);
                        }}
                      />
                    }
                    label="Shipping address is the same as billing address"
                  />
                </div>

              </>
              {/* end payment detail form */}

              {/* shipping details form  */}
              {!sameAsBilling &&
                <>

                  <div className='address-main' style={{ marginTop: '20px' }}>
                    <div style={{ backgroundColor: primaryBackgroundColor, borderRadius: '30px', border: '1px solid #8F8F8F' }}>
                      <Helmet>
                        <title>Address | Boundless Giving</title>
                      </Helmet>

                      <div className={`address-information-container `}>

                        <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '20px' }}>Shipping Details</h3>

                        {<form style={{ borderRadius: '30px' }}>

                          <div className='address-info-name'>
                            <div style={{ color: primaryColor }} className='address-info_sub_heading'>
                              Full Name <span style={{ color: redColor }}>*</span>
                            </div>
                            <input
                              style={{ border: `1px solid ${primaryColor}`, backgroundColor: primaryBackgroundColor }}
                              onChange={(e) => setToFirstName(e.target.value)}
                              value={toFirstName}
                              type='text'
                              name='first-name'
                              autoComplete='first name'
                              placeholder='First Name'
                              required
                            />
                            <input
                              onChange={(e) => setToLastName(e.target.value)}
                              value={toLastName}
                              type='text'
                              name='last-name'
                              autoComplete='last name'
                              placeholder='Last Name'
                              required
                              style={{ border: `1px solid ${primaryColor}`, backgroundColor: primaryBackgroundColor }}
                            />
                          </div>
                          <div style={{ marginTop: '37px' }} className='address-info-address'>
                            <header className='address-info__heading' style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                              Address
                            </header>
                            <input
                              onChange={(e) => setAddress1(e.target.value)}
                              value={address1}
                              type='text'
                              name='address1'
                              autoComplete='address 1'
                              placeholder='Address 1'
                              required
                              style={{ border: `1px solid ${primaryColor}`, backgroundColor: primaryBackgroundColor }}
                            />
                            <input
                              onChange={(e) => setAddress2(e.target.value)}
                              value={address2}
                              type='text'
                              name='address2'
                              autoComplete='address 2'
                              placeholder='Address 2'
                              style={{ border: `1px solid ${primaryColor}`, backgroundColor: primaryBackgroundColor }}
                            />
                            <input
                              onChange={(e) => setCity(e.target.value)}
                              value={city}
                              type='text'
                              name='city'
                              autoComplete='city'
                              placeholder='City'
                              required
                              style={{ border: `1px solid ${primaryColor}`, backgroundColor: primaryBackgroundColor }}
                            />

                            <FormControl sx={{ width: 1, marginBottom: 3 }}>
                              <Select
                                required
                                displayEmpty
                                defaultValue={cityState || ''}
                                name='state'
                                value={cityState || ''}
                                onChange={(e) => {
                                  setCityState(e.target.value)
                                  handGuestTax(totalTaxablePrice(cartItems), e.target.value)
                                  calculateSalesTax(e.target.value)
                                }
                                }
                                sx={{
                                  fontSize: '0.8rem',
                                  height: 36,
                                  width: '100%',
                                  marginBottom: '20px',
                                  backgroundColor: primaryBackgroundColor,
                                  borderRadius: '8px',
                                  border: `1px solid ${primaryColor}`,
                                  '.MuiOutlinedInput-notchedOutline': {
                                    border: 0,
                                    outline: 'none',
                                  },
                                }}
                              >
                                <MenuItem disabled value=''>
                                  <span
                                    style={{
                                      color: primaryColor,
                                      // fontFamily: 'AvenirNext',
                                      fontSize: '14px',
                                    }}
                                  >
                                    Select State
                                  </span>
                                </MenuItem>
                                {country
                                  ? updatedState(country).map((item) => (
                                    <MenuItem key={item.value} value={item.value}>
                                      {item.label}
                                    </MenuItem>
                                  ))
                                  : []}
                              </Select>
                            </FormControl>
                            <div className='address-info_half_inp'>
                              <input
                                onChange={(e) => setZip(e.target.value)}
                                value={zip}
                                type='number'
                                name='zip'
                                autoComplete='zip'
                                placeholder='Zip'
                                required
                                onWheel={(e) => e.target.blur()}
                                style={{ border: `1px solid ${primaryColor}`, backgroundColor: primaryBackgroundColor, width: '100%' }}
                              />

                              <FormControl style={{ width: '100%' }}>
                                <Select
                                  required
                                  displayEmpty
                                  name='country'
                                  value={country || ''}
                                  onChange={(e) => {
                                    setPhone('');
                                    setCountry(country);
                                  }}
                                  sx={{
                                    fontSize: '0.8rem',
                                    height: 36,
                                    width: '100%',
                                    backgroundColor: primaryBackgroundColor,
                                    border: `1px solid ${primaryColor}`,
                                    borderRadius: '8px',
                                    '.MuiOutlinedInput-notchedOutline': {
                                      border: 0,
                                      outline: 'none',
                                    },
                                  }}
                                >
                                  <MenuItem disabled value=''>
                                    <span
                                      style={{
                                        color: primaryColor,
                                        // fontFamily: 'AvenirNext',
                                        fontSize: '14px',
                                      }}
                                    >
                                      Select Country
                                    </span>
                                  </MenuItem>
                                  {countries.map((item) => (
                                    <MenuItem key={item.value} value={item.value}>
                                      {item.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>

                          </div>
                            <div style={{ marginTop: '20px' }} className='address-info-phone'>
                          <header className='address-info__heading' style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                            Contact Number
                            {/* <span style={{ color: redColor }}>*</span> */}
                          </header>
                          <InputMask
                            autoComplete="none" 
                            ref={phoneRef}
                            mask="999-999-9999"
                            placeholder={`+${codesObj[country] ? codesObj[country] : 'Phone'}`}
                            maskChar=""
                            value={addressPhone}
                            onChange={handlePhone}
                            required
                            style={{ marginBottom: '30px', border: `1px solid ${primaryColor}`, backgroundColor: primaryBackgroundColor }}
                          />

                        </div>
                        </form>}
                      </div>
                    </div>


                  </div>

                </>
              }
              {/* end shipping details form  */}

            </div>
          </Grid>
          <Grid item xs={12} md={4} order={{ xs: 1, md: 2 }} >
            <div style={{
              position: 'sticky',
              top: '30px',           // Adjust as needed (e.g., header height)
              zIndex: 10
            }}>
              <div style={{ backgroundColor: 'white', borderRadius: '30px' }}>
                <div className="item-carts" >
                  {cartItems.length > 0 ? (
                    cartItems?.map((item, i) => {
                      const imageUrl = item.auction_item.assets?.find(
                        (img) =>
                          img.context_type === "thumbnail" ||
                          img.context_type === "portrait"
                      )?.name;

                      return (
                        <React.Fragment key={i}>
                          <div className="item-cart" key={i}>
                            <div className="cart-">
                              <img
                                src={imageUrl}
                                alt="Product"
                                className="item-image"
                              />
                            </div>
                            <div className="item-details">
                              <p>{item.auction_item.name}</p>
                              <div className="quantity-control">
                                <div>
                                  <button
                                    onClick={() =>
                                      handleQuantityDecrement(item)
                                    }
                                  >
                                    -
                                  </button>
                                  <span> {item.quantity}</span>
                                  <Tooltip
                                    title={
                                      checkMaxQuantity(item)
                                        ? "You have reached maximum quantity"
                                        : ""
                                    }
                                  >
                                    <button
                                      onClick={() => handleQtyIncrement(item)}
                                    >
                                      +
                                    </button>
                                  </Tooltip>
                                </div>

                              </div>
                            </div>
                            <div className="item-price">
                              <div className="cart-card-remove_price">
                                <p style={{ color: primaryColor, fontWeight: "600", fontWeight: 'bold', textDecoration: currentDiscountFromAuction[0] && (Number(getVariantDiscount(item.auction_item?.store_item?.variant, item?.auction_item)) !== 0 || Number(getDiscount(item.auction_item)) !== 0) ? 'line-through' : 'none' }} >
                                  {item.auction_item.store_item.variant
                                    ? ` $${(item.quantity * Number(getDisplayVariantPrice(item.auction_item?.store_item?.variant, item?.auction_item))).toFixed(2)}`
                                    : ` $${(item.quantity * Number(getDisplayPrice(item.auction_item))).toFixed(2)}`}
                                </p>
                                {/* <p>(${(donationPrice).toFixed(2)} Donation Impact)</p> */}
                              </div>
                              {(Number(getVariantDiscount(item.auction_item?.store_item?.variant, item?.auction_item)) !== 0 ||
                                Number(getDiscount(item.auction_item)) !== 0) &&
                                currentDiscountFromAuction[0] && <p style={{ color: "var(--red-color)", fontWeight: "600" }}>
                                  {
                                    item.auction_item.store_item.variant
                                      ? `$${(item.quantity * (Number(getDisplayVariantPrice(item.auction_item?.store_item?.variant, item?.auction_item)) - Number(getVariantDiscount(item.auction_item?.store_item?.variant, item?.auction_item)))).toFixed(2)}`
                                      : `$${(item.quantity * (Number(getDisplayPrice(item.auction_item)) - Number(getDiscount(item.auction_item)))).toFixed(2)}`
                                  } Impact Sale Price
                                </p>}
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <p className="empty_cart">Your cart is empty.</p>
                  )}
                </div>
                <div className="custom-borde">
                  <div className="cart-expenditure">
                    <div className="subtotal">
                      <h2>Subtotal</h2>
                      <h2>
                        ${Number(price).toFixed(2)}
                      </h2>
                    </div>

                    {currentDiscountFromAuction[0] &&
                      <div className="subtotal">
                        <h2 >{showDiscountPercentage ? `Additional Discount (${currentDiscountFromAuction[0]} %)` : 'Extra Additional Discount'}</h2>
                        <h2 >-${Number(discountPrice).toFixed(2)}</h2>
                      </div>}

                    <div className="subtotal">
                      <h2>Shipping</h2>
                      <h2>${Number(shippingRate).toFixed(2)}</h2>
                    </div>


                    {tax?.amount > 0 && (
                      <div className="subtotal">
                        <h2>
                          Tax{" "}
                          <span>
                            ({`${tax?.amount === 0 ? 0 : tax?.percentage}%`})
                          </span>
                        </h2>
                        <h2>${tax.amount.toFixed(2)}</h2>
                      </div>
                    )}

                    <div>
                      <div className="subtotal">
                        <h2>
                          Processing Fees <span>(3%) </span>
                        </h2>
                        <h2>
                          $
                          {Number(calcFinalPrice(price, shippingRate, tax).proccessingFees).toFixed(2)}
                        </h2>
                      </div>
                    </div>
                    <div
                      style={{
                        color: "red",
                      }}
                      className="subtotal"
                    >
                      <h2 style={{ fontSize: "26px" }}>You Pay</h2>
                      <h2 style={{ fontSize: "26px" }}>
                        ${Number(calcFinalPrice(price, shippingRate, tax).totalAmount - Number(discountPrice).toFixed(2)).toFixed(2)}
                      </h2>
                    </div>
                    <div className="subtotal">
                      <h2>Amount Donated</h2>
                      <h2>${calculateTotalDonation().toFixed(2) || 0}</h2>
                    </div>
                  </div>
                </div>
              </div>
              <button style={{ cursor: cartItems.length < 1 ? 'not-allowed' : 'pointer' }} className="pay-now-btn" onClick={handleCheckout} disabled={cartItems.length < 1}>
                Pay Now
              </button>
            </div>
          </Grid>

        </Grid>
      </div>
      <NewFooterV2 />
      {/* <ConfirmAlertLogin
        openConfirmAlert={openConfirmAlert}
        handleCloseConfirmAlert={handleCloseConfirmAlert}
        context={{
          returnUrl: '/cart-checkout'
        }}
      /> */}
      <DialogMui isOpen={alerts} message={alertMsg} ButtonText={'Close'} handleClick={() => { (setAlert(false)) }} />

    </>
  )
}

export default GuestCheckout

const Label = styled(
  ({
    children,
    className,
  }: {
    children?: React.ReactNode,
    className?: string,
  }) => {
    const formControlContext = useFormControlContext();
    const [dirty, setDirty] = React.useState(false);

    React.useEffect(() => {
      if (formControlContext?.filled) {
        setDirty(true);
      }
    }, [formControlContext]);

    if (formControlContext === undefined) {
      return <p>{children}</p>;
    }

    const { error, required, filled } = formControlContext;
    const showRequiredError = dirty && required && !filled;

    return (
      <p
        className={clsx(className, error || showRequiredError ? "invalid" : "")}
      >
        {children}
        {required ? " *" : ""}
      </p>
    );
  }
)`
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 0.875rem;
  margin-bottom: 4px;

  &.invalid {
    color: red;
  }
`;

const HelperText = styled((props: {}) => {
  const formControlContext = useFormControlContext();
  const [dirty, setDirty] = React.useState(false);

  React.useEffect(() => {
    if (formControlContext?.filled) {
      setDirty(true);
    }
  }, [formControlContext]);

  if (formControlContext === undefined) {
    return null;
  }

  const { required, filled } = formControlContext;
  const showRequiredError = dirty && required && !filled;

  return showRequiredError ? <p {...props}>This field is required.</p> : null;
})`
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 0.875rem;
`;